/**
 * Company name for packing slips — Standard A4 header, Cheetah outside label (prominent),
 * and Cheetah stub checkout. Prefer Firestore account companyName, then OrderDesk
 * customer/shipping company, then legacy checkout "Customer ID" (often a company dump).
 */

function getCheckoutDataObject(order) {
  const cd = order?.checkout_data || order?.checkoutData;
  if (cd && typeof cd === 'object' && !Array.isArray(cd)) return cd;
  return null;
}

export function resolvePackingSlipCompanyName(order) {
  const cd = getCheckoutDataObject(order) || {};
  const candidates = [
    order?._accountDelivery?.companyName,
    order?.accountCompanyName,
    order?.customer?.company,
    order?.customerCompany,
    order?.companyName,
    order?.shipping?.company,
    order?.shippingCompany,
    order?.shipping_company,
    cd.Company,
    cd['Customer ID'],
    order?.customer_id,
    order?.customerId,
  ];
  for (const value of candidates) {
    const text = String(value || '').trim();
    if (text) return text;
  }
  return '';
}

/**
 * Replace OrderDesk "Customer ID" with "Company" using the resolved company name.
 */
export function applyCompanyCheckoutLine(lines, order) {
  const list = Array.isArray(lines) ? [...lines] : [];
  const company = resolvePackingSlipCompanyName(order);
  const withoutLegacy = list.filter((row) => {
    const key = String(row?.key || '').trim().toLowerCase();
    return key !== 'customer id' && key !== 'company';
  });
  if (!company) return withoutLegacy;

  const companyLine = { key: 'Company', val: company };
  const deliveryIdx = withoutLegacy.findIndex(
    (row) => String(row?.key || '').trim().toLowerCase() === 'delivery',
  );
  if (deliveryIdx >= 0) {
    withoutLegacy.splice(deliveryIdx + 1, 0, companyLine);
    return withoutLegacy;
  }
  const dispatchIdx = withoutLegacy.findIndex(
    (row) => String(row?.key || '').trim().toLowerCase() === 'dispatch',
  );
  if (dispatchIdx >= 0) {
    withoutLegacy.splice(dispatchIdx, 0, companyLine);
    return withoutLegacy;
  }
  withoutLegacy.push(companyLine);
  return withoutLegacy;
}
